import { useContext } from 'react';
import ThemeContext from './CustomerContext';

const useThemeContext = () => useContext(ThemeContext);

export default useThemeContext;
